<template>
  <v-container fluid id="container">
    <v-row justify="center" no-gutters>
      <v-col cols="12">
        <img id="tos-text-img" justify="center" src="@/assets/agreement_list.png">
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Audience',
}
</script>

<style scoped>
#container {
  padding: 0;
  background: black;
}

#tos-text-img {
  width: 100%;
}
</style>
